if (!customElements.get("avaliability-notification-drawer")) {
  customElements.define(
    "avaliability-notification-drawer",
    class AvaliabilityNotificationDrawer extends HTMLElement {
      constructor() {
        super();

        const closeElementsSelectors = [
          ".avaliability-notification-drawer-close",
          ".avaliability-notification-overlay",
        ];

        this.querySelectorAll(closeElementsSelectors).forEach((closeEl) => {
          closeEl.addEventListener("click", () => {
            this.hide();
          });
        });

        this.openBtn = document.querySelector(
          ".avaliability-notification-open-btn"
        );

        this.openBtn?.addEventListener("click", (e) => {
          this.show(e.currentTarget);
        });

        this.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && this.hasAttribute("open")) {
            event.preventDefault();
            this.hide();
          }
        });
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        this.setTrafficSource();
        this.setOpenBtnStatus();

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const currentVariant = event.data.variant;
            this.resetStatus();
            this.updateInfo(currentVariant);
          }
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      hide() {
        this.removeAttribute("open");
        this.classList.remove("modal--open");
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        this.classList.add("modal--open");
        document.body.classList.add("overflow-hidden");

        requestAnimationFrame(() => {
          if (!this.hasAttribute("open")) return;
          const target = this.querySelector(".form__message--success, [aria-invalid='true'], [role='dialog']");
          trapFocus(this, target);
        });
      }

      // Where this visit came from, captured on landing by _support_scripts.
      setTrafficSource() {
        const source = this.querySelector("[data-notification-source]");
        if (!source || typeof window.olasTrafficSource !== "function") return;
        source.value = window.olasTrafficSource();
      }

      setOpenBtnStatus() {
        const form = this.querySelector("form");
        if (!form || window.location.hash !== `#${form.id}`) return;
        const success = form.querySelector(".form__message--success");
        const error = form.querySelector(".form__message--error");
        if (!success && !error) return;
        if (success && this.openBtn) this.openBtn.dataset.status = "success";
        this.show(this.openBtn);
      }

      updateInfo(currentVariant) {
        if (!currentVariant) return;
        const tags = this.querySelector("[data-notification-tags]");
        if (tags) tags.value = tags.value.replace(/olas_variant_\d+/, `olas_variant_${currentVariant.id}`);
        const formattedOptions =
          currentVariant.options.length > 1
            ? currentVariant.options.join(" / ")
            : currentVariant.options[0] || "";

        const optionsEl = this.querySelector(
          "[data-notification-options-label]"
        );
        const inputOptions = this.querySelector("[data-notification-options]");
        const inputBody = this.querySelector("[data-notification-body]");

        if (optionsEl) optionsEl.textContent = formattedOptions;
        if (inputOptions) {
          const previous = inputOptions.value;
          inputOptions.value = formattedOptions;
          // The request body names the size too; keep it in step with the pill.
          if (inputBody && previous && inputBody.value.includes(previous)) {
            inputBody.value = inputBody.value.replace(previous, formattedOptions);
          }
        }

        const inputReturn = this.querySelector("[data-notification-return]");

        if (inputReturn && inputReturn.value.includes("variant=")) {
          const newUrl = inputReturn.value.replace(
            /variant=\d+/,
            `variant=${currentVariant.id}`
          );
          inputReturn.value = newUrl;
        }
      }

      resetStatus() {
        if (this.querySelector("olas-signup")) return;
        const messages = this.querySelectorAll(".form__message");
        messages.forEach((el) => el.remove());

        if (this.openBtn) {
          this.openBtn.dataset.status = "false";
        }
      }
    }
  );
}
